/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Incremental_RunsInputs */

const en_svchip_incremental_runs = /** @type {(inputs: Svchip_Incremental_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incremental runs`)
};

const ar_svchip_incremental_runs = /** @type {(inputs: Svchip_Incremental_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تشغيلات تزايدية`)
};

const bn_svchip_incremental_runs = /** @type {(inputs: Svchip_Incremental_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইনক্রিমেন্টাল রান`)
};

const de_svchip_incremental_runs = /** @type {(inputs: Svchip_Incremental_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inkrementelle Läufe`)
};

const es_svchip_incremental_runs = /** @type {(inputs: Svchip_Incremental_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecuciones incrementales`)
};

const fr_svchip_incremental_runs = /** @type {(inputs: Svchip_Incremental_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exécutions incrémentielles`)
};

const pt_svchip_incremental_runs = /** @type {(inputs: Svchip_Incremental_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Execuções incrementais`)
};

const zh_svchip_incremental_runs = /** @type {(inputs: Svchip_Incremental_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`增量运行`)
};

const tr_svchip_incremental_runs = /** @type {(inputs: Svchip_Incremental_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artımlı çalıştırmalar`)
};

const ru_svchip_incremental_runs = /** @type {(inputs: Svchip_Incremental_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дополнительные запуски`)
};

const pl_svchip_incremental_runs = /** @type {(inputs: Svchip_Incremental_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uruchomienia przyrostowe`)
};

/**
* | output |
* | --- |
* | "Incremental runs" |
*
* @param {Svchip_Incremental_RunsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_incremental_runs = /** @type {((inputs?: Svchip_Incremental_RunsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Incremental_RunsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_incremental_runs(inputs)
	if (locale === "bn") return bn_svchip_incremental_runs(inputs)
	if (locale === "de") return de_svchip_incremental_runs(inputs)
	if (locale === "es") return es_svchip_incremental_runs(inputs)
	if (locale === "fr") return fr_svchip_incremental_runs(inputs)
	if (locale === "pt") return pt_svchip_incremental_runs(inputs)
	if (locale === "zh") return zh_svchip_incremental_runs(inputs)
	if (locale === "tr") return tr_svchip_incremental_runs(inputs)
	if (locale === "ru") return ru_svchip_incremental_runs(inputs)
	if (locale === "pl") return pl_svchip_incremental_runs(inputs)
	return en_svchip_incremental_runs(inputs)
});